module.exports = __webpack_public_path__ + "media/images/favicon-708a730f19f8dc8cc070533fade2d854.ico";